<template lang="html">
  <v-flex
    shrink
    text-center
  >
    <v-flex
      v-if="!errorState"
      class="subheading success--text"
      text-center
    >
      {{ `${value ? 'Calculation Ready' : 'Calculating...'}` }}
    </v-flex>
    <div class="loader-wrap">
      <v-scale-transition>
        <div
          v-if="value || errorState"
          class="loader-holder"
        >
          <v-layout
            fill-height
            align-center
            justify-center
            ma-0
          >
            <v-flex shrink>
              <v-icon
                size="55"
                :color="errorState ? 'error' : 'success'"
              >
                {{ errorState ? 'error' : 'done' }}
              </v-icon>
            </v-flex>
          </v-layout>
        </div>
      </v-scale-transition>
      <div class="loader-holder">
        <v-progress-circular
          :width="4"
          :value="progress"
          :color="errorState ? 'error' : 'success'"
          :indeterminate="!value && !errorState"
          :size="88"
        />
      </div>
    </div>
    <v-alert
      v-if="errorState"
      type="error"
      class="text-left mt-3"
    >
      There was an error performing your calculation, <br>
      Please try again and if the problem persists contact us for assistance.
    </v-alert>
  </v-flex>
</template>

<script>
// import { mapGetters } from 'vuex'
import { rtdb } from '@/plugins/firebase'
import helpers from '@/mixins/helpers'

export default {
  mixins: [ helpers ],
  props: {
    value: Boolean,
    commenced: Boolean,
    errorPath: String
  },
  data () {
    return {
      progress: 0,
      error: false
    }
  },
  computed: {
    // ...mapGetters([]),
    errorState () {
      return this.error && !this.value
    }
  },
  watch: {
    commenced () {
      this.setErrorTimer()
    },
    value (v) {
      setTimeout(() => {
        if (v) this.progress = 100
      }, 10)
    },
    error (v) {
      setTimeout(() => {
        if (v) this.progress = 100
      }, 10)
    }
  },
  mounted () {
    if (this.commenced) this.setErrorTimer()
  },
  beforeDestroy () {
    if (this.errorPath) rtdb.ref(this.errorPath).off()
  },
  methods: {
    setErrorTimer () {
      setTimeout(() => { this.error = true }, 60000)
      if (this.errorPath) {
        rtdb.ref(this.errorPath).on('value', s => {
          if (s.val()) this.error = true
        })
      }
    }
  }
}
</script>

<style lang="css" scoped>
.si-tool-heading-divider {
  height: 2px;
}
.loader-holder{
 position: absolute;
 height: 88px;
 width: 88px;
}
.loader-wrap{
 position: relative;
 height: 88px;
 width: 88px;
 margin: 0 auto;
}
</style>
